export enum AuthScenariosEnumeration {
  ABOUT_EXPIRING = 'about-expiring',
  ACCESS = 'access',
  REFRESH = 'refresh',
  REDIRECTING = 'redirecting',
}
